// extracted by mini-css-extract-plugin
export var textSlider = "style-mod--text-slider--421a0";
export var textSliderContainer = "style-mod--text-slider-container--feb95";